import type { AiReviewFlag } from "../aiReview.types";

// Owner-tunable display values of the "To review" page.
export const AI_REVIEW = {
  PAGE_SIZE: 20,
  // The sidebar badge has no socket: it polls the count.
  COUNT_POLL_MS: 300_000,
  // The score badge is "high" from HIGH, "medium" from MEDIUM, else "low".
  SCORE_LEVELS: { HIGH: 8, MEDIUM: 4 }
} as const;

// The sub-codes the backend writes (contract §19.5). Any other value is
// ignored.
export const AI_REVIEW_DETAILS: Record<AiReviewFlag, readonly string[]> = {
  F1: ["exhausted", "error", "alert_ticket"],
  F2: ["escalated"],
  F3: [
    "announced-nothing",
    "claimed-cart-change",
    "narrated-nothing",
    "claimed-order",
    "unchecked-delivery-day",
    "scaffold-only",
    "claimed-none-found",
    "announced-empty-list"
  ],
  F4: ["words", "exclamations", "shouting"],
  F5: ["repeated_question", "pushes"],
  F6: ["voice_unread", "asked_to_retype", "customer_correction"],
  F7: ["bracket_line"],
  F8: ["admin_after_ai"],
  F9: ["repeated_message"]
};
